// extracted by mini-css-extract-plugin
export default {"systemRolePermissions":"systemRolePermissions--UQEjMmSkBX","matrix":"matrix--F7EfDrB2kx"};